import store from '@/store';

export function manageContent({ meta }) {
  const settings = meta.appElementSettings || [];

  if (settings.includes('miniSidebar') && !store.state.common.sidebarMini) {
    store.commit('common/setSidebarMini', true);
  } else if (!settings.includes('miniSidebar') && store.state.common.sidebarMini) {
    store.commit('common/setSidebarMini', false);
  }

  if (settings.includes('hideSidebar') && !store.state.common.hideSidebar) {
    store.commit('common/setHideSidebar', true);
    console.log('true');
  } else if (!settings.includes('hideSidebar') && store.state.common.hideSidebar) {
    console.log('false');
    store.commit('common/setHideSidebar', false);
  }

  if (settings.includes('hideToolbar') && !store.state.common.hideToolbar) {
    store.commit('common/setHideToolbar', true);
  } else if (!settings.includes('hideToolbar') && store.state.common.hideToolbar) {
    store.commit('common/setHideToolbar', false);
  }
}
